module.exports = __webpack_public_path__ + "assets/img/9.1c415578.png";